<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getCatalogs } from '@/request/api'

export default {

  // 初始化获取菜单信息并存储到vuex
  beforeCreate () {
    getCatalogs().then(res => {
      this.$store.commit('setCatalogs', res.data.rtData)
      console.log(res.data.rtData)
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fafafa;
  /* 灰白页面
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); */
}
</style>
